export const container: CSSFunction = () => ({
  position: 'relative',
  display: 'flex',
  justifyContent: 'center',
});

export const tooltip: CSSFunction = ({ theme }) => ({
  display: 'inline-block',
  maxWidth: '250px',
  padding: '8px',
  textAlign: 'left',
  color: theme.colors.text[3],
  width: 'max-content',
  backgroundColor: theme.colors.background.black,
  borderRadius: '4px',
  position: 'relative',
});

export const arrowBase: CssStyles = {
  content: '""',
  position: 'absolute',
  borderStyle: 'solid',
};

export const tooltipPositionTop: CSSFunction = ({ theme }) => ({
  position: 'fixed',
  transform: 'translate(calc(-50% + 8px), calc(-105% - 8px))',
  '::after': {
    ...arrowBase,
    top: 'calc(100% - 1px)',
    left: '50%',
    transform: 'translateX(-50%)',
    borderWidth: '8px 8px 0 8px',
    borderColor: `${theme.colors.background.black} transparent transparent transparent`,
  },
});

export const tooltipText: CSSFunction = ({ theme }) => ({
  fontSize: '14px',
  fontFamily: theme.fonts.tvFont,
  color: theme.colors.background.default,
});

export const tooltipPositionTopRight: CSSFunction = ({ theme }) => ({
  position: 'fixed',
  transform: 'translate(-8px, calc(-105% - 8px))',
  '::after': {
    ...arrowBase,
    top: 'calc(100% - 1px)',
    left: '8px',
    borderWidth: '8px 8px 0 8px',
    borderColor: `${theme.colors.background.black} transparent transparent transparent`,
  },
});
